import { useState } from 'react';

/**
 * WidgetFooter
 * Discreet footer used at the bottom of every public widget.
 * Shows "Propulsé par ResaWork" + a tiny copyable widget ID badge so that
 * a webmaster or support agent can identify which exact widget is embedded
 * without having to read the iframe src.
 */
export default function WidgetFooter({ widgetId, isPremium = false }) {
  const [copied, setCopied] = useState(false);

  const copyId = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    try {
      await navigator.clipboard.writeText(String(widgetId || ''));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_e) {
      // ignore — best effort
    }
  };

  return (
    <div className="mt-6 space-y-1.5 select-none">
      {!isPremium && (
        <div className="flex items-baseline justify-center gap-1.5 text-xs text-gray-400">
          <span>Propulsé par</span>
          <a href="https://resawork.fr" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
            <img src="/logo.png" alt="ResaWork" className="h-4 object-contain" style={{ verticalAlign: 'baseline', marginBottom: '-2px' }} />
          </a>
        </div>
      )}
      {widgetId && (
        <button
          type="button"
          onClick={copyId}
          className="mx-auto block text-[10px] text-gray-300 hover:text-gray-500 font-mono tracking-tight transition-colors"
          title="Identifiant du widget — cliquez pour copier"
          data-testid="widget-public-id"
        >
          {copied ? '✓ ID copié' : <>ID&nbsp;:&nbsp;{widgetId}</>}
        </button>
      )}
    </div>
  );
}
